export default __webpack_public_path__ + "static/media/homeDark.112d4d26.svg";